const isAxiosLikeError = (
  err: unknown
): err is {
  isAxiosError?: boolean;
  response?: { status?: number; data?: { detail?: unknown } };
  message?: string;
} =>
  typeof err === "object" &&
  err !== null &&
  ("isAxiosError" in err || "response" in err);

export const getAccessProfileErrorMessage = (err: unknown): string => {
  if (isAxiosLikeError(err)) {
    const status = err.response?.status;
    const detail =
      typeof err.response?.data?.detail === "string" ? err.response.data.detail : null;

    if (status === 503 && detail === "Authentication service temporarily unavailable") {
      return "Authentication could not be verified because Cognito signing keys are temporarily unavailable.";
    }
    if (status === 503 && detail === "Authentication service misconfigured") {
      return "Authentication could not be verified because the local backend Cognito configuration is incomplete.";
    }
    if (detail) return detail;
    if (status) return `Request failed with status ${status}.`;
  }

  return err instanceof Error ? err.message : "Failed to load access profile";
};
